import { Component, Input, OnInit } from '@angular/core'
import { FormControl, FormGroup, Validators } from '@angular/forms'
import { Pattern } from 'src/app/shared/constants/patterns.constant'
import { BranchInformationModel, UpdateSocialAccModel } from '../../models/branch-information.model'
import { OrganizationsService } from '../../services/organizations.service'
import { Subscription } from 'rxjs'
import { TranslateService } from '@ngx-translate/core'
import { ToastrService } from 'ngx-toastr'

@Component({
	selector: 'app-organization-branch-social-accounts',
	templateUrl: './organization-branch-social-accounts.component.html',
	styleUrls: ['./organization-branch-social-accounts.component.scss'],
})
export class OrganizationBranchSocialAccountsComponent implements OnInit {
	@Input() branchInformationData!: BranchInformationModel
	subscription = new Subscription()
	socialAccForm : FormGroup = new FormGroup({})
	editMode = false
	oldValues = null
	isChanged = false
	constructor(
		private organizationService: OrganizationsService,
		private translate: TranslateService,
		private toaster: ToastrService
	) {}

	ngOnInit(): void {
		this.initForm()
	}

	initForm() {
		this.socialAccForm = new FormGroup({
			id: new FormControl(this.branchInformationData?.id),
			facebookLink: new FormControl(this.branchInformationData.facebookLink, [
				Validators.pattern(Pattern.facebookUrlPattern),
			]),

			instagramLink: new FormControl(
				this.branchInformationData.instagramLink,
				Validators.pattern(Pattern.instagramUrlPattern)
			),
		})
		this.socialAccForm.disable()
		this.oldValues = this.socialAccForm.getRawValue()

		this.subscription.add(
			this.socialAccForm.valueChanges.subscribe(
				(res) =>
					(this.isChanged =
						JSON.stringify(this.oldValues) != JSON.stringify(res))
			)
		)
	}
	changeEditMode() {
		this.editMode = !this.editMode
		this.editMode ? this.socialAccForm.enable() : this.socialAccForm.disable()
	}
	getController(controlName: string) {
		return (this.socialAccForm as FormGroup).controls[controlName] as FormControl
	}

	update() {
		const body: UpdateSocialAccModel = {
			id: this.branchInformationData.id,
			...this.socialAccForm.getRawValue(),
		}
		this.subscription.add(
			this.organizationService.updateSocialAccounts(body).subscribe((res) => {
				this.branchInformationData.instagramLink = body.instagramLink
				this.branchInformationData.facebookLink = body.facebookLink

				this.editMode = false
				this.socialAccForm.disable()
				this.toaster.success(this.translate.instant('TOASTER.MSG_SUCCESS'))
			})
		)
	}

	ngOnDestroy() {
		this.subscription.unsubscribe()
	}
}
